import { StyleRules } from '@material-ui/core';
import { AppTheme } from 'types/themeTypes';

export default (theme: AppTheme): StyleRules => {
  const { textColorNew, backgroundColorsNew } = theme.palette;

  return {
    linkWrapper: {
      '& a': {
        color: 'inherit',
        textDecoration: 'none',
      },
      '& a::visited': {
        color: 'inherit',
        textDecoration: 'none',
      },
      '& button': {
        alignSelf: 'center',
      },
      backgroundColor: backgroundColorsNew.dialog,
      borderRadius: '12px',
      boxShadow: `0px 1px 15px 0px rgba(0, 0, 0, 0.2)`,
      color: textColorNew.primary,
      display: 'flex',
      maxWidth: '310px',
      padding: '14px',
      textDecoration: 'none',
    },
  };
};
